import React from 'react'

import { DataAttribute } from '@frame/types'

import { useGetFileUploadContext } from '../hooks/useGetFileUploadContext'

export function FullScreenDropzone({ children }: { children?: React.ReactNode }) {
  const {
    showDropzone,
    dropzone: { getRootProps, getInputProps },
  } = useGetFileUploadContext()

  return (
    <div
      {...(showDropzone ? getRootProps({ className: 'dropzone' }) : {})}
      className="fixed left-0 top-0 flex h-full w-full items-center justify-center"
    >
      {showDropzone && <input data-cy={DataAttribute.FILE_UPLOADER} {...getInputProps()} type="file" />}
      {children}
    </div>
  )
}
